/**
 *
 * TabularMenu
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Text } from '@cashfree-intl/coherent';

import './style.scss';

function TabularMenu({ activeMenu, onItemClick, menuItems }) {
  const onClick = obj => e => onItemClick(e, obj);

  return (
    <div className="tabular-menu pointer">
      {menuItems.map(obj => (
        <Text
          key={obj.key}
          variant="b14"
          strong
          className={activeMenu === obj.key ? 'active' : ''}
          color={activeMenu === obj.key ? 'primary' : ''}
          onClick={onClick(obj)}
        >
          {obj.name}
        </Text>
      ))}
    </div>
  );
}

TabularMenu.propTypes = {
  activeMenu: PropTypes.string.isRequired,
  onItemClick: PropTypes.func.isRequired,
  menuItems: PropTypes.array.isRequired,
};

export default memo(TabularMenu);
